import React from 'react'
import styles from './wrapper.module.scss'

export const MainWrapper = (props) => {

    return (
        <div className={styles.wrapper}>
            {props.children}
        </div>
    )
}